import React from 'react';
import { styled } from '@mui/material/styles';

const filterProps = ['center', 'dontCenter', 'fullWidth', 'fullHeight', 'right', 'spaceBetween', 'wrap'];

const StyledRow = styled('div', {
  shouldForwardProp: (prop) => !filterProps.includes(prop),
})(({ center, dontCenter, fullWidth, fullHeight, right, spaceBetween, wrap }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  ...(center && { justifyContent: 'center' }),
  ...(dontCenter && { alignItems: 'flex-start' }),
  ...(fullWidth && { width: '100%' }),
  ...(fullHeight && { flex: 1, height: '100%' }),
  ...(right && { justifyContent: 'right' }),
  ...(spaceBetween && { justifyContent: 'space-between' }),
  ...(wrap && { flexWrap: 'wrap' }),
}));

const StyledColumn = styled('div', {
  shouldForwardProp: (prop) => !filterProps.includes(prop),
})(({ center, fullWidth, fullHeight }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: center ? 'center' : 'flex-start',
  ...(center && { justifyContent: 'center' }),
  ...(fullWidth && { width: '100%' }),
  ...(fullHeight && { flex: 1, height: '100%' }),
}));

export const Row = (props) => {
  return <StyledRow {...props} />;
};

export const Column = (props) => {
  return <StyledColumn {...props} />;
};
